import React from 'react';
import { motion } from 'framer-motion';

export default function CGV() {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <section className="bg-secondary/30 py-12 sm:py-16">
        <div className="container-custom text-center px-4">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-3xl sm:text-4xl md:text-5xl font-serif mb-4"
          >
            Conditions Générales de Vente
          </motion.h1>
        </div>
      </section>

      <div className="container-custom max-w-3xl px-4 py-10 sm:py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="space-y-10"
        >

          {/* CGV Principales */}
          <section>
            <h2 className="text-2xl sm:text-3xl font-serif mb-6 pb-2 border-b border-border">CGV Principales</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-serif mb-2">Article 1 – Objet</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les présentes CGV encadrent les prestations de soins esthétiques proposées par Glow Shape.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">Article 2 – Réservation</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  La réservation en ligne s'effectue via le site https://glowshape.fr. Elle est confirmée après enregistrement d'un moyen de paiement valide.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">Article 3 – Tarifs et paiement</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les prix sont indiqués en euros, sans TVA (TVA non applicable – art. 293 B du CGI). Un acompte de 30 % du montant total est débité automatiquement le jour du rendez-vous à 8h00. Le solde (70 %) est réglé directement au salon.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">Article 4 – Politique d'annulation</h3>
                <div className="space-y-3 mt-2">
                  <div className="bg-green-50 border border-green-200 rounded-sm p-4">
                    <p className="text-sm font-medium text-green-800 mb-1">✓ Annulation plus de 48h avant le rendez-vous</p>
                    <p className="text-sm text-green-700">Annulation gratuite, aucun débit effectué.</p>
                  </div>
                  <div className="bg-amber-50 border border-amber-200 rounded-sm p-4">
                    <p className="text-sm font-medium text-amber-800 mb-1">⚠ Annulation moins de 48h avant le rendez-vous</p>
                    <p className="text-sm text-amber-700">L'acompte de 30 % sera débité à titre de dédommagement.</p>
                  </div>
                  <div className="bg-red-50 border border-red-200 rounded-sm p-4">
                    <p className="text-sm font-medium text-red-800 mb-1">✗ Absence sans prévenir (no-show)</p>
                    <p className="text-sm text-red-700">L'acompte de 30 % sera débité intégralement.</p>
                  </div>
                </div>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">Article 5 – Sécurité des paiements</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les paiements sont sécurisés par Stripe, certifié PCI DSS. Les coordonnées bancaires ne sont jamais stockées sur nos serveurs.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">Article 6 – Contre-indications</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Le client est tenu d'informer l'esthéticienne de tout problème de santé, allergie ou contre-indication pouvant affecter le déroulement des soins.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">Article 7 – Réclamations</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Toute réclamation doit être formulée dans les 48 heures suivant la prestation via la page Contact. Nous nous engageons à y répondre dans un délai de 5 jours ouvrés.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">Article 8 – Droit applicable</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les présentes CGV sont régies par le droit français. En cas de litige, une solution amiable sera recherchée en priorité. À défaut, les tribunaux français seront compétents.
                </p>
              </div>
            </div>
          </section>

          <hr className="border-border" />

          {/* CGV Formation */}
          <section>
            <h2 className="text-2xl sm:text-3xl font-serif mb-6 pb-2 border-b border-border">Conditions Générales de Vente – Formations</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-serif mb-2">1. Objet</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les présentes CGV encadrent la vente de formations proposées par Glow Shape, en présentiel et à distance, dans le domaine de l'esthétique.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">2. Inscription</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Toute inscription à une formation est validée après signature du contrat ou validation du paiement.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">3. Tarifs</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les prix sont indiqués en euros, sans TVA (TVA non applicable – art. 293 B du CGI).
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">4. Paiement</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Le paiement peut être exigé en totalité ou en plusieurs fois selon les modalités définies. Un acompte de 30 % est demandé pour réserver la formation en présentiel. Concernant la formation distancielle, l'intégralité du montant sera dû au moment de l'inscription. L'envoi du e-book se fera par la suite sur votre boîte mail.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">5. Annulation</h3>
                <div className="space-y-2 mt-2">
                  <p className="text-sm font-medium text-muted-foreground">Annulation par la cliente :</p>
                  <ul className="list-disc list-inside text-muted-foreground text-sm leading-relaxed space-y-1 ml-2">
                    <li>Plus de 14 jours avant → remboursement possible</li>
                    <li>Moins de 14 jours → acompte conservé</li>
                    <li>Absence → aucun remboursement</li>
                  </ul>
                  <p className="text-sm font-medium text-muted-foreground mt-3">Annulation par Glow Shape :</p>
                  <p className="text-muted-foreground text-sm ml-2">Remboursement total ou report proposé.</p>
                </div>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">6. Déroulement</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Glow Shape s'engage à fournir les moyens pédagogiques nécessaires. La cliente s'engage à être assidue et à respecter les règles.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">7. Responsabilité</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Glow Shape est tenue à une obligation de moyens. Les résultats dépendent de l'implication de la participante.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">8. Propriété intellectuelle</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les supports de formation sont protégés et ne peuvent être copiés, diffusés ou revendus.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">9. Droit de rétractation</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Le droit de rétractation ne s'applique pas si la formation débute avant la fin du délai de 14 jours avec accord de la cliente.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">10. Litiges</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les litiges seront soumis aux mêmes règles que les CGV principales.
                </p>
              </div>
            </div>
          </section>

          <hr className="border-border" />

          {/* Conditions de collaboration */}
          <section>
            <h2 className="text-2xl sm:text-3xl font-serif mb-6 pb-2 border-b border-border">Conditions de collaboration</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-serif mb-2">1. Objet</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Glow Shape propose des collaborations avec des (micro) influenceurs en échange de prestations offertes.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">2. Engagements</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">L'influenceur s'engage à :</p>
                <ul className="list-disc list-inside text-muted-foreground text-sm leading-relaxed mt-2 space-y-1">
                  <li>publier du contenu (story, post, réel) ;</li>
                  <li>mentionner Glow Shape ;</li>
                  <li>partager une expérience authentique.</li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">3. Contrepartie</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Glow Shape offre une prestation gratuite en échange de visibilité.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">4. Droit à l'image</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Glow Shape peut repartager les contenus publiés.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">5. Non-respect</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  En cas de non-publication, Glow Shape se réserve le droit de facturer la prestation.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">6. Indépendance</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  L'influenceur reste libre dans son contenu mais doit respecter les règles de transparence (contenu sponsorisé).
                </p>
              </div>
            </div>
          </section>

          <hr className="border-border" />

          {/* CGV Boutique */}
          <section>
            <h2 className="text-2xl sm:text-3xl font-serif mb-6 pb-2 border-b border-border">Conditions de vente – Produits</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-serif mb-2">1. Objet</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les présentes conditions encadrent la vente de produits proposés par Glow Shape.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">2. Produits</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les produits sont décrits avec le plus de précision possible.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">3. Prix</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Les prix sont en euros, sans TVA (TVA non applicable – art. 293 B du CGI).
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">4. Paiement</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Le paiement est exigé immédiatement lors de l'achat.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">5. Retour et remboursement</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Pour des raisons d'hygiène, les produits ouverts ou utilisés ne sont ni repris ni échangés.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">6. Droit de rétractation (vente à distance)</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Le client dispose de 14 jours pour exercer son droit de rétractation (produit non utilisé et retourné à ses frais).
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">7. Responsabilité</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Glow Shape ne peut être tenue responsable d'une mauvaise utilisation du produit.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-serif mb-2">8. Litiges</h3>
                <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  Tout litige sera traité conformément aux CGV générales.
                </p>
              </div>
            </div>
          </section>

        </motion.div>
      </div>
    </div>
  );
}
